import { render, staticRenderFns } from "./updatePersinList.vue?vue&type=template&id=440fcfce&scoped=true&"
import script from "./updatePersinList.vue?vue&type=script&lang=js&"
export * from "./updatePersinList.vue?vue&type=script&lang=js&"
import style0 from "./updatePersinList.vue?vue&type=style&index=0&id=440fcfce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fcfce",
  null
  
)

export default component.exports